import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { TanStackDevtools } from "@tanstack/react-devtools";

import * as TanstackQuery from "./integrations/tanstack-query/root-provider";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_APP_SENTERY_DNS,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      networkDetailAllowUrls: [
        /dev\.testesaj\.ir/,
        /gateway\.esaj\.ir/,
        /stage\.testesaj\.ir/,
      ],
      networkRequestHeaders: ["content-type", "authorization"],
      networkResponseHeaders: ["content-type"],
    }),
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.4,
  tracePropagationTargets: ["localhost", /^api/],
  replaysSessionSampleRate: 0.4,
  replaysOnErrorSampleRate: 0.4,
});

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

import "./styles.css";
import reportWebVitals from "./reportWebVitals.ts";
import OperatorProvider from "./stores/operator-store.tsx";
import { NuqsAdapter } from "nuqs/adapters/react";

// import { registerSW } from 'virtual:pwa-register'

// const updateSW = registerSW({
//   onNeedRefresh() {
//     updateSW(true) // Force reload
//   },
//   onOfflineReady() {
//     console.log('PWA is ready to work offline')
//   },
// })

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    ...TanstackQuery.getContext(),
  },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <TanstackQuery.Provider>
      <NuqsAdapter>
        <OperatorProvider>
          <RouterProvider router={router} />
        </OperatorProvider>
        {import.meta.env.DEV && (
          <TanStackDevtools
            config={{
              inspectHotkey: ["Shift", "Meta", "S"],
            }}
          />
        )}
      </NuqsAdapter>
    </TanstackQuery.Provider>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
